import { render, staticRenderFns } from "./shoppingCartView.vue?vue&type=template&id=84109a8c&scoped=true"
import script from "./shoppingCartView.vue?vue&type=script&lang=js"
export * from "./shoppingCartView.vue?vue&type=script&lang=js"
import style0 from "./shoppingCartView.vue?vue&type=style&index=0&id=84109a8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84109a8c",
  null
  
)

export default component.exports